export enum TagProductType {
  Highlight = 'highlight',
  Purple = 'purple',
  Rappi = 'rappi',
  Pro = 'pro',
  Pay = 'pay',
  RappiCard = 'rappi-card',
  ProBlack = 'pro-black',
  Marriott = 'marriott',
  Informative = 'informative',
}
